<template>
  <div class="overlay">
    <div class="has-margin-top-3">
      <div class="overlay_header">
            <span class="title is-size-7 is-uppercase">Beschreibung</span>
            <button class="button is-small is-primary button--close-overlay" @click="closeOverlay">X</button>
      </div>
      <div class="overlay_body" v-html="formatLongText(rowData.description)">
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        rowData: {
            type: Object,
            required: true
        },
        rowIndex: {
            type: Number
        },
    },
    methods: {
        formatLongText(value) {
            let returnValue = '';
            let valueArr = value.split(/[\n]/g);
            if (valueArr.length === 1) return `<p class="table-text"> ${valueArr[0]}</p>`

            valueArr.forEach(x => {
                return returnValue += `<p class="table-text"> ${x} </p>`
            });

            return returnValue;
        },
        closeOverlay() {
            this.$emit('hide-detail-row');
        }
    },
}
</script>

<style>
    .overlay {
        z-index: 10000;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: white;
    }

    .overlay_header {
        width: calc(100% - 2rem);
        padding: 1rem;
        display: flex;
        justify-content: space-between;
    }

    .overlay_body {
        padding: 1rem;
        width: calc(100% - 2rem);
        overflow-y: scroll;
        max-height: 100vh;
    }

    p.table-text {
        white-space: normal;
    }

    .button--close-overlay {

    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/contactListDetailRow.vue